import React, { useState, useEffect, useMemo } from 'react';
import { REGEXP_ONLY_DIGITS } from "input-otp";
import { InputOTP, InputOTPGroup, InputOTPSlot } from "../../components/TwoFactor/InputOTPComponent";
import { ReactComponent as LogoSVG } from "../../assets/svg/akinrobotics-logo.svg";
import { useMutation } from '@tanstack/react-query';
import { loginVerify } from '../../services/ApiServices';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useSelector } from 'react-redux';

const TwoFactorPage = () => {
    //const [verifyForm, setVerifyForm] = useState({ Guid:'', VerifyKey: '' });
    const [timeLeft, setTimeLeft] = useState(180);
    const history = useHistory();

    //const {guid,verifyKey} = useSelector((state) => state.Auth);
    const [guid, setGuid] = useState('');
    const [verifyKey, setVerifyKey] = useState('');

    useEffect(() => {

        console.log("guid", guid);
        var guid = localStorage.getItem("guid");

        if (!guid) {
            history.push("/");
          return;
        }
    
        //setVerifyForm(prev => ({ ...prev, Guid: guid }))
        setGuid(guid);
      }, [guid])

    const mutation = useMutation(loginVerify, {
        onSuccess: (value) => {
          const token = value.data.token;

          console.log("token: ", token);
          if (token.Check === undefined) {
            localStorage.setItem("jwtHeader", token);

            history.push("/home");
          } else {
            toast.error(
              "Girilmiş olan kullanıcı verileri sistemdekiler ile eşleşmemektedir.",
              { position: "top-center" }
            );
          }
        },
        onError: (error) => {
          // Hata durumunu burada ele alıyoruz
          console.error("Login error: ", error);
          toast.error(
            "Giriş işlemi sırasında bir hata oluştu. Lütfen tekrar deneyin.",
            { position: "top-center" }
          );
        },
      });

    useEffect(() => {
        // Eğer zaman bitti ise, sayacı durdur
        if (timeLeft <= 0) {
            toast.error("Doğrulama kodu belirlenen süre içerisinde girilmedi. Lütfen tekrar giriş yapın.")
            localStorage.removeItem("guid");
            return;
        }

        // Her saniye zamanı güncelle
        const intervalId = setInterval(() => {
            setTimeLeft(prevTime => prevTime - 1);
        }, 1000);

        // component unmount olduğunda intervalı temizle
        return () => clearInterval(intervalId);
    }, [timeLeft]);

    // useEffect(() => {
    //     return () => {
    //       dispatch(SetGuid(null))
    //     }
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [])

    const timeLeftView = useMemo(() => {
        const minutes = Math.floor(timeLeft / 60);
        const seconds = timeLeft % 60;

        return `${minutes < 10 ? `0${minutes}` : minutes} : ${seconds < 10 ? `0${seconds}` : seconds}`
    }, [timeLeft]);

    const handleInputChange = (value) => {
        //setVerifyForm((prev) => ({ ...prev, VerifyKey: value }));
        setVerifyKey(value);
    };

    const signInVerifyHandler = () => {
        //const { Guid,VerifyKey } = verifyForm;
        console.log("success");
        console.log("guid", guid);
        console.log("verifyKey", verifyKey);
        mutation.mutate({
            Guid:guid,
            VerifyKey:verifyKey,
          })
    };

    return (
        <>
            <div
                className="h-screen w-full fixed overflow-hidden bg-center bg-gradient-to-tr from-white to-gray-200"
                style={{
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                }}
            >
                <div className="flex m-auto flex-col items-center justify-center  mx-auto w-full px-6 py-6 h-full lg:py-0 backdrop-blur-xl">
                    <div className="md:flex flex items-center justify-center   text-2xl  font-semibold text-gray-900 ">
                        <LogoSVG className="md:h-20 md:w-28 h-10  " />
                    </div>
                    <div className="w-full  bg-white rounded-lg shadow  md:mt-0 sm:max-w-md xl:p-0 mt-2">
                        <div className="p-8 space-y-4 md:space-y-6 sm:p-8">
                                <h2 className="text-xl font-semibold text-gray-900 text-center mb-4">Hesabını Doğrula</h2>
                                <p className="text-sm text-gray-600 text-center mb-6">
                                    Hesabınıza kayıtlı email adresinize gönderilen 6 karakterli doğrulama kodunu girin. (122333)
                                </p>

                                <div className="w-full flex justify-center mb-6">
                                    <InputOTP
                                        maxLength={6}
                                        value={verifyKey}
                                        pattern={REGEXP_ONLY_DIGITS}
                                        onChange={handleInputChange}
                                        onComplete={signInVerifyHandler}
                                    >
                                        <InputOTPGroup>
                                            {[...Array(6)].map((_, index) => (
                                                <InputOTPSlot
                                                    key={index}
                                                    index={index}
                                                    className="w-12 h-12"
                                                />
                                            ))}
                                        </InputOTPGroup>
                                    </InputOTP>
                                </div>

                                <div className="mb-4 text-center text-sm text-gray-600">
                                    <span>Geçerli süre: {timeLeftView}</span>
                                </div>

                                <div className="text-center mt-4">
                                    <a href="/login" className="flex justify-center items-center text-gray-500 text-sm font-light hover:text-black hover:underline">
                                        <span className="mr-2">&lt;</span> Giriş sayfasına geri dön
                                    </a>
                                </div>
                                <p className="text-sm font-light text-gray-500 ">
                Copyright © 1995 - 2025 AKINROBOTICS | İnsana Değer - Her Hakkı
                Saklıdır
              </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="md:hidden flex">
                <LogoSVG className="h-20 w-28  " />
            </div>
        </>
    );

}

export default TwoFactorPage;
